import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import CloseIcon from '@mui/icons-material/Close';

const ModalConfirmation = ({
  openDialog,
  handleCloseDialog,
  handleCloseModalDialog,
}) => {
  const companyTheme = CompanyTheme();
  return (
    <Dialog
      open={openDialog}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'  sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant='h3'>Confirmation</Typography>
        <IconButton
          onClick={handleCloseDialog}
          sx={{ color: 'grey.600' }}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          <Typography sx={{ fontSize: '16px', fontWeight: 'bold' }}>
            <span style={{ color: 'red' }}>
              Would you like to close the modal without saving?
            </span>
          </Typography>
        </DialogContentText>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ padding: '16px' }}>
        <Button
          onClick={handleCloseModalDialog}
          variant="contained"
          sx={{
            backgroundColor: companyTheme ? companyTheme.primary.main : '#1976d2',
            color: '#fff',
            '&:hover': {
              backgroundColor: companyTheme
                ? companyTheme.primary.dark
                : '#1565c0',
            },
          }}
        >
          Yes
        </Button>
        <Button
          onClick={handleCloseDialog}
          variant="contained"
          sx={{
            backgroundColor: '#9e9e9e',
            color: '#fff',
            '&:hover': {
              backgroundColor: '#757575',
            },
          }}
        >
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ModalConfirmation;

ModalConfirmation.propTypes = {
  openDialog: PropTypes.bool,
  handleCloseDialog: PropTypes.func,
  handleCloseModalDialog: PropTypes.func,
};
